import { Indicator, Notification, NotificationProps } from '@mantine/core';

type NotificationWrapperProps = {
  index?: number;
  children: React.ReactNode;
  indicator?: boolean;
  label?: string;
  onClose?: (key?: number) => void;
  size?: 'compact' | 'tall';
  style?: React.CSSProperties;
  styles?: NotificationProps['styles'];
  variant: 'neutral' | 'tertiary' | 'success' | 'caution';
  icon?: React.ReactNode;
  // a11y: optional landmark role and an accessible name for the close button.
  // Both default to no-op so existing call sites are unchanged; page-level
  // banners opt in.
  role?: 'alert' | 'status';
  closeButtonLabel?: string;
};

export default function NotificationWrapper({
  index,
  children,
  indicator,
  label,
  size,
  style,
  styles,
  onClose,
  icon,
  variant = 'neutral',
  role,
  closeButtonLabel,
}: NotificationWrapperProps) {
  const indicatorVariant = variant === 'neutral' || variant === 'tertiary' ? 'active' : variant;
  return (
    <Notification
      closeButtonProps={{ size: 16, 'aria-label': closeButtonLabel }}
      data-testid="alertBanner"
      data-size={size}
      role={role}
      icon={icon || (indicator && <Indicator label={label || null} variant={indicatorVariant} />)}
      onClose={onClose ? () => onClose(index) : () => {}}
      style={style}
      styles={styles}
      variant={variant}
      withCloseButton={!!onClose}
    >
      {children}
    </Notification>
  );
}
